var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarenheitAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.66667 8.5C6.74619 8.5 6 7.7165 6 6.75C6 5.7835 6.74619 5 7.66667 5C8.58714 5 9.33333 5.7835 9.33333 6.75C9.33333 7.7165 8.58714 8.5 7.66667 8.5ZM12.9664 17.7221C12.9664 18.5279 12.54 19 11.8165 19C11.0931 19 10.6667 18.5279 10.6667 17.7221V8.37791C10.6667 7.57209 11.0931 7.1 11.8165 7.1H16.9567C17.5888 7.1 18 7.48256 18 8.11744C18 8.75233 17.5812 9.13488 16.9567 9.13488H12.9664V12.2767H16.5836C17.1776 12.2767 17.5659 12.643 17.5659 13.2453C17.5659 13.8558 17.1852 14.2221 16.5836 14.2221H12.9664V17.7221Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarenheitAlt);
export default __webpack_public_path__ + "static/media/farenheit-alt.7fb7035b11c689d8708fc8cde77c9c55.svg";
export { ForwardRef as ReactComponent };